import React from 'react';

import {
    Text

} from './styles' 

const TextSuggestion = (props) => {
    return (
        <Text>
            {props.children}
        </Text>
    );
};

export default TextSuggestion;